import { render, staticRenderFns } from "./emitEnhanceface.vue?vue&type=template&id=a252cae2&scoped=true"
import script from "./emitEnhanceface.vue?vue&type=script&lang=js"
export * from "./emitEnhanceface.vue?vue&type=script&lang=js"
import style0 from "./emitEnhanceface.vue?vue&type=style&index=0&id=a252cae2&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a252cae2",
  null
  
)

export default component.exports